import { getCarrierServiceLabel } from "@redotech/redo-fulfillment-carrier-common/carrier-service-labels";
import { CarrierAndService } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useState } from "react";
import { groupBenchmarkServices } from "./dynamic-rate-pricing-service-groups";
import { DynamicRatePricingServiceLabel } from "./dynamic-rate-pricing-service-label";

function serviceOption(
  group: ReturnType<typeof groupBenchmarkServices>[number],
): BadgeRedoListItem<CarrierAndService[]> {
  return {
    id: group.key,
    value: group.services,
    type: "badge",
    badge: { text: <DynamicRatePricingServiceLabel source={group.source} /> },
  };
}

export const DynamicRatePricingBenchmarkPicker = memo(
  function DynamicRatePricingBenchmarkPicker({
    disabled,
    options,
    value,
    onChange,
  }: {
    disabled: boolean;
    options: CarrierAndService[];
    value: CarrierAndService[];
    onChange(value: CarrierAndService[]): void;
  }) {
    const [search, setSearch] = useState("");
    const terms = search.toLowerCase().trim().split(/\s+/);
    const filteredOptions = groupBenchmarkServices(options).filter(
      ({ source }) => {
        const label =
          `${getCarrierServiceLabel(source.carrier, source.service)} ${source.carrier} ${source.service}`.toLowerCase();
        return terms.every((term) => label.includes(term));
      },
    );
    return (
      <RedoTagsDropdownInput
        disabled={disabled}
        onDropdownOpenChange={() => setSearch("")}
        options={filteredOptions.map(serviceOption)}
        placeholder="Select benchmark services"
        searchPlaceholder="Search carriers or services"
        searchString={search}
        selectedOptions={groupBenchmarkServices(value).map(serviceOption)}
        setSearchString={setSearch}
        setSelectedOptions={(selected) =>
          onChange(selected.flatMap((item) => item.value))
        }
        size="xs"
      />
    );
  },
);
